module.exports = __webpack_public_path__ + "static/media/calendar-Blue.6770d5d0.svg";